// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.36842 3H14.6316V21H9.36842V3Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 9H7.26316V21H2V9Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 11H16.7368V21H22V11Z"}}]};

const LeaderboardFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'leaderboard-filled',
    ref,
    icon: element,
  },
));

LeaderboardFilledIcon.displayName = 'LeaderboardFilledIcon';

export default LeaderboardFilledIcon;
